export default "<div>\n  <p class=\"details\">{{title}} <span kz-event-type-title event-type=\"value\"></span></p>\n</div>\n";